<section
  #nativeHtmlCard
  class="scene-card-base"
  [ngClass]="{
    'selected': isSelected && scene,
    'scene-card': scene,
}"
  (click)="sceneSelected()"
>
  @if (scene) {
  <div class="thumbnail-container" [ngClass]="{ skeleton: !isImageDownloaded }">
    <img
      [src]="scene.thumbnail_url"
      [alt]="scene.title"
      (load)="onImageDownloaded()"
    />
  </div>
  <div class="scene-info">
    <p class="scene-label">{{ scene.title }}</p>
    <div class="scene-time">
      <img src="assets/static/icons/time.svg" alt="" />
      <p class="scene-time-text">
        {{ secondsToTime(scene.start_time_in_seconds) }}
      </p>
    </div>
  </div>
  } @else {
  <div class="thumbnail-container skeleton"></div>
  <div class="scene-info">
    <p class="scene-label skeleton">Loading label...</p>
    <p class="scene-time skeleton">00:00:00</p>
  </div>
  }
</section>
